import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import Home from "./Views/Home";
import ListView from "./Views/ListView";

export default class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/boards/:id" component={ListView} />
        </Switch>
      </div>
    );
  }
}
